<section class="navMaker p-5" style="text-align: center;">
    <nav class="printch">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-sales" role="tab" aria-controls="nav-home" aria-selected="true">Nogal Payments</a>
            <a class="nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-Customer" role="tab" aria-controls="nav-profile" aria-selected="false">Customers Payments</a>
            <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Supplier Payments</a>
            <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-sales0" role="tab" aria-controls="nav-contact" aria-selected="false">Area Payments</a>
            <a class="nav-link" id="nav-admin-tab" data-toggle="tab" href="#nav-admin" role="tab" aria-controls="nav-contact" aria-selected="false">Transactions</a>
        </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <!-- !!!: Nogal Payments -->
        <div class="tab-pane fade show active" id="nav-sales" role="tabpanel" aria-labelledby="nav-profile-tab">
            <form class="p-3 printch" style="padding-bottom: 0 !important;">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFrom' type="date" class="form-control fromDA" (change)='pipeAreaSales()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateTo' type="date" class="form-control toDA" (change)='pipeAreaSales()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
          <div class="col-6">
              <button type="submit" class="btn btn-primary">Sign in</button>
          </div>
      </div> -->
            </form>
            <!-- !!!: sales invoice Area -->

            <div class="col-12">
                <div class="card" style='margin-bottom: 0 !important;background-color: transparent !important;'>
                    <div class="card-header" style='padding: 0;background-color: transparent !important;'>
                        <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-2 col-12 lastU mt-1">
                                    <!-- <label>Print : </label><br> -->
                                    <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                                </div>
                                <div class="col-lg-4"></div>
                            </div>
                        </div>
                        <h2 class="supplierto mt-2 mb-2" style="text-align: center;display: block !important;"><span class='supplier3'> From Date : {{dateFrom}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                            <span class='supplier4'> To Date : {{dateTo}} </span>
                            <span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Amount : {{totalArea}} </span>
                        </h2>
                        <div class="card-body" style="padding: 0 !important;">
                            <div class="table-responsive dfg" style="overflow: auto;height: 37.4vh;">


                                <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                                    <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                                        <thead>
                                            <tr>
                                                <th style='text-align: center;'>No</th>
                                                <th scope="col">Invoice_No</th>
                                                <!-- <th scope="col">Order Date</th>
<th scope="col">Shipping Date</th> -->
                                                <th scope="col">Date</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Amount_After_Discount</th>
                                                <!-- <th scope="col">Dimensions</th>
  <th scope="col">Finishing/fabrics</th>
  <th scope="col">Category</th> -->
                                                <!-- <th scope="col">In</th>
                          <th scope="col">Out</th>
                          <th scope="col">Reseved</th>
                          <th scope="col">Available</th>
                          <th scope="col">Defect</th>
                          <th scope="col">Sales</th>
                          <th scope="col">Notes</th> -->
                                                <!-- <th scope="col">Branch</th>
  <th scope="col">Price</th>
  <th scope="col">Supplier</th>
  <th scope="col">PI.NO</th>
  <th scope="col">Sales</th> -->
                                                <!-- <th scope="col">User</th> -->
                                                <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
  <th scope="col" class='no' *ngIf='delete'>Delete</th>
  <th scope="col" class='no'>Barcode</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor='let v of areeAllSales|dateComOrder:dateFrom:dateTo|orderOnly; let n = index;'>
                                                <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                                <td data-title="Invoice_No">{{v.id}}</td>
                                                <!-- <td data-title="Order Date">{{v.dateorder}}</td>
<td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                                <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
  <td data-title="Finishing/fabrics">{{v.fabric}}</td>
  <td data-title="Category">{{v.categoryname}}</td> -->
                                                <td data-title="Date">{{v.dateorder|date:'dd-MM-yyyy'}}</td>
                                                <td data-title="Name">{{v.nameClient}}</td>
                                                <!-- <td data-title="Description">
                                    <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                </td> -->
                                                <td data-title="Amount_After_Discount">{{v.totalprice - (v.totalprice * (v.discound / 100 ))}}</td>
                                                <!-- <td data-title="Defect">{{v.defect}}</td>
                          <td data-title="Sales">{{v.sales}}</td>
                          <td data-title="Notes">
                              <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                          </td> -->
                                                <!-- <td data-title="Branch">{{v.rootname}}</td>
  <td data-title="Price">{{v.price}}</td>
  <td data-title="Supplier">{{v.suppliername}}</td>
  <td data-title="PI NO">{{v.pino}}</td>
  <td data-title="Sales">{{v.sales}}</td> -->
                                                <!-- <td data-title="Password" >{{v.username}}</td> -->

                                                <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
  <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
  </td>
  <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
  </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
                    </div>
                </div>
            </div>
        </div>
        <!-- !!!: Customer Payments -->
        <div class="tab-pane fade" id="nav-Customer" role="tabpanel" aria-labelledby="nav-profile-tab">
            <form class="p-3 printch" style="padding-bottom: 0 !important;">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Customer</label>
                    <div class="col-6 lastU09">
                        <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN" style="height: unset !important;">
                <option value="undefined" disabled selected>Customer</option>
                <option value="All">All</option>
                <option *ngFor='let r of arreCustomer' [value]="r.id">{{r.name}}</option>
              </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromCustomer' type="date" class="form-control fromDA" (change)='pipeAreaSales0()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToCustomer' type="date" class="form-control toDA" (change)='pipeAreaSales0()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
        <div class="col-6">
            <button type="submit" class="btn btn-primary">Sign in</button>
        </div>
    </div> -->
            </form>
            <!-- !!!: sales invoice Area -->

            <div class="col-12">
                <div class="card" style='margin-bottom: 0 !important;background-color: transparent !important;'>
                    <div class="card-header" style='padding: 0;background-color: transparent !important;'>
                        <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-2 col-12 lastU mt-1">
                                    <!-- <label>Print : </label><br> -->
                                    <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                                </div>
                                <div class="col-lg-4"></div>
                            </div>
                        </div>
                        <h2 class="supplierto mt-2 mb-2" style="text-align: center;display: block !important;"><span class='supplier3'> From Date : {{dateFromCustomer}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                            <span class='supplier4'> To Date : {{dateToCustomer}} </span>
                            <span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Amount : {{totalArea0}} </span>
                        </h2>
                        <div class="card-body" style="padding: 0 !important;">
                            <div class="table-responsive dfg" style="overflow: auto;height: 37.4vh;">


                                <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                                    <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                                        <thead>
                                            <tr>
                                                <th style='text-align: center;'>No</th>
                                                <th scope="col">Invoice_No</th>
                                                <!-- <th scope="col">Order Date</th>
<th scope="col">Shipping Date</th> -->
                                                <th scope="col">Date</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Amount_After_Discount</th>
                                                <!-- <th scope="col">Dimensions</th>
<th scope="col">Finishing/fabrics</th>
<th scope="col">Category</th> -->
                                                <!-- <th scope="col">In</th>
                        <th scope="col">Out</th>
                        <th scope="col">Reseved</th>
                        <th scope="col">Available</th>
                        <th scope="col">Defect</th>
                        <th scope="col">Sales</th>
                        <th scope="col">Notes</th> -->
                                                <!-- <th scope="col">Branch</th>
<th scope="col">Price</th>
<th scope="col">Supplier</th>
<th scope="col">PI.NO</th>
<th scope="col">Sales</th> -->
                                                <!-- <th scope="col">User</th> -->
                                                <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
<th scope="col" class='no' *ngIf='delete'>Delete</th>
<th scope="col" class='no'>Barcode</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor='let v of areeAllSales|dateComOrder:dateFromCustomer:dateToCustomer|orderOnly|customerId:yarbsS; let n = index;'>
                                                <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                                <td data-title="Invoice_No">{{v.id}}</td>
                                                <!-- <td data-title="Order Date">{{v.dateorder}}</td>
<td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                                <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
<td data-title="Finishing/fabrics">{{v.fabric}}</td>
<td data-title="Category">{{v.categoryname}}</td> -->
                                                <td data-title="Date">{{v.dateorder|date:'dd-MM-yyyy'}}</td>
                                                <td data-title="Name">{{v.nameClient}}</td>
                                                <!-- <td data-title="Description">
                                  <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                              </td> -->
                                                <td data-title="Amount_After_Discount">{{v.totalprice - (v.totalprice * (v.discound / 100 ))}}</td>
                                                <!-- <td data-title="Defect">{{v.defect}}</td>
                        <td data-title="Sales">{{v.sales}}</td>
                        <td data-title="Notes">
                            <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                        </td> -->
                                                <!-- <td data-title="Branch">{{v.rootname}}</td>
<td data-title="Price">{{v.price}}</td>
<td data-title="Supplier">{{v.suppliername}}</td>
<td data-title="PI NO">{{v.pino}}</td>
<td data-title="Sales">{{v.sales}}</td> -->
                                                <!-- <td data-title="Password" >{{v.username}}</td> -->

                                                <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
<td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
</td>
<td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
</td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
                    </div>
                </div>
            </div>
        </div>
        <!-- !!!: Supplier -->
        <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-home-tab">
            <form class="p-3 printch" style="padding-bottom: 0 !important;">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Company : </label>
                    <div class="col-6 lastU09">
                        <select [(ngModel)]='searchsupplierAdmin' name='searchsupplierAdmin' class="form-control select2 searchsupplierAdmin">
                        <option disabled>Search By Company</option>
                        <option>All</option>
                        <option *ngFor='let w of supplierA' [value]="w.id">Name : {{w.name}} || code : {{w.id}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromSu' type="date" class="form-control fromDA" (change)='pipeFilterSupplier()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToSu' type="date" class="form-control toDA" (change)='pipeFilterSupplier()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                  <div class="col-6">
                      <button type="submit" class="btn btn-primary">Sign in</button>
                  </div>
              </div> -->
            </form>
            <!-- !!!: Supplier Table invoice -->

            <div class="col-12" style="display: block !important;">
                <div class="card" style='margin-bottom: 0 !important;background-color: transparent !important;'>
                    <div class="card-header" style='padding: 0;background-color: transparent !important;'>
                        <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-2 col-12 lastU mt-1">
                                    <!-- <label>Print : </label><br> -->
                                    <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary printch" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                                </div>
                                <div class="col-lg-4"></div>
                            </div>
                        </div>
                        <h2 class=" mt-2 mb-2" style="text-align: center;"><span class='supplier3'> From Date : {{dateFromSu}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier4'> To Date : {{dateToSu}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>                            <span class='supplier4'> Total : {{totalArea00}} </span> </h2>
                        <div class="card-body" style="padding: 0 !important;">
                            <div class="table-responsive dfg" style="overflow: auto;height: 37.4vh;">


                                <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                                    <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                                        <thead>
                                            <tr>
                                                <th style='text-align: center;'>No</th>
                                                <th scope="col">Invoice_No</th>
                                                <!-- <th scope="col">Order Date</th>
      <th scope="col">Shipping Date</th> -->
                                                <th scope="col">Date</th>
                                                <th scope="col">Item_Code</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Quantity</th>
                                                <!-- <th scope="col">Dimensions</th>
        <th scope="col">Finishing/fabrics</th>
        <th scope="col">Category</th> -->
                                                <!-- <th scope="col">In</th>
                                <th scope="col">Out</th>
                                <th scope="col">Reseved</th>
                                <th scope="col">Available</th>
                                <th scope="col">Defect</th>
                                <th scope="col">Sales</th>
                                <th scope="col">Notes</th> -->
                                                <!-- <th scope="col">Branch</th>
        <th scope="col">Price</th>
        <th scope="col">Supplier</th>
        <th scope="col">PI.NO</th>
        <th scope="col">Sales</th> -->
                                                <!-- <th scope="col">User</th> -->
                                                <th scope="col" class='no'>Photo</th>
                                                <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
        <th scope="col" class='no' *ngIf='delete'>Delete</th>
        <th scope="col" class='no'>Barcode</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor='let v of arreReportCustomer|searchSupplier:searchsupplierAdmin|dateCom:dateFromSu:dateToSu|orderOnly; let n = index;'>
                                                <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                                <td data-title="Invoice_No">{{v.id_boked}}</td>
                                                <!-- <td data-title="Order Date">{{v.dateorder}}</td>
      <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                                <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
        <td data-title="Finishing/fabrics">{{v.fabric}}</td>
        <td data-title="Category">{{v.categoryname}}</td> -->
                                                <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                                <td data-title="Item_Code">{{v.code}}</td>
                                                <td data-title="Description">
                                                    <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                                </td>
                                                <td data-title="Quantity">{{v.qty}}</td>
                                                <!-- <td data-title="Defect">{{v.defect}}</td>
                                <td data-title="Sales">{{v.sales}}</td>
                                <td data-title="Notes">
                                    <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                </td> -->
                                                <!-- <td data-title="Branch">{{v.rootname}}</td>
        <td data-title="Price">{{v.price}}</td>
        <td data-title="Supplier">{{v.suppliername}}</td>
        <td data-title="PI NO">{{v.pino}}</td>
        <td data-title="Sales">{{v.sales}}</td> -->
                                                <!-- <td data-title="Password" >{{v.username}}</td> -->
                                                <td data-title="Photo" class='no'>
                                                    <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                                </td>
                                                <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
        <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
        </td>
        <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
        </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
                    </div>
                </div>
            </div>
        </div>
        <!-- !!!: Sales -->
        <div class="tab-pane fade" id="nav-sales0" role="tabpanel" aria-labelledby="nav-profile-tab">
            <form class="p-3 printch" style="padding-bottom: 0px !important;">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Area : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mt-4 sO submitNumber select2 areaSelect" style="height: unset !important;">
                      <option selected disabled>Search By Area</option>
                      <option value="All">All</option>
                      <option *ngFor='let r of arreCustomer|noRepeatArea' [value]="r.area">{{r.area}}</option>
                      </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromAnoter' type="date" class="form-control fromDA" (change)='pipeAreaSalesAnother()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToAnoter' type="date" class="form-control toDA" (change)='pipeAreaSalesAnother()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
              <div class="col-6">
                  <button type="submit" class="btn btn-primary">Sign in</button>
              </div>
          </div> -->
            </form>
            <!-- !!!: sales invoice Area -->

            <div class="col-12">
                <div class="card" style='margin-bottom: 0 !important;background-color:transparent !important;'>
                    <div class="card-header" style='padding: 0;background-color:transparent !important;'>
                        <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-2 col-12 lastU mt-1">
                                    <!-- <label>Print : </label><br> -->
                                    <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                                </div>
                                <div class="col-lg-4"></div>
                            </div>
                        </div>
                        <h2 class="mt-2 mb-2" style="text-align: center;"><span>Area : {{yarbs000All0Sales}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='supplier3'> From Date : {{dateFromAnoter}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                            <span class='supplier4'> To Date : {{dateToAnoter}} </span>
                            <span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Amount : {{totalAreaAnother}} </span>
                        </h2>
                        <div class="card-body" style="padding: 0 !important;">
                            <div class="table-responsive dfg" style="overflow: auto;height: 37.4vh;">


                                <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                                    <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                                        <thead>
                                            <tr>
                                                <th style='text-align: center;'>No</th>
                                                <th scope="col">Invoice_No</th>
                                                <th scope="col">Area</th>
                                                <!-- <th scope="col">Order Date</th>
  <th scope="col">Shipping Date</th> -->
                                                <th scope="col">Date</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Amount_After_Discount</th>
                                                <!-- <th scope="col">Dimensions</th>
    <th scope="col">Finishing/fabrics</th>
    <th scope="col">Category</th> -->
                                                <!-- <th scope="col">In</th>
                            <th scope="col">Out</th>
                            <th scope="col">Reseved</th>
                            <th scope="col">Available</th>
                            <th scope="col">Defect</th>
                            <th scope="col">Sales</th>
                            <th scope="col">Notes</th> -->
                                                <!-- <th scope="col">Branch</th>
    <th scope="col">Price</th>
    <th scope="col">Supplier</th>
    <th scope="col">PI.NO</th>
    <th scope="col">Sales</th> -->
                                                <!-- <th scope="col">User</th> -->
                                                <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
    <th scope="col" class='no' *ngIf='delete'>Delete</th>
    <th scope="col" class='no'>Barcode</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor='let v of areeAllSales|areaFilter:yarbs000All0Sales|dateComOrder:dateFromAnoter:dateToAnoter|orderOnly; let n = index;'>
                                                <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                                <td data-title="Invoice_No">{{v.id}}</td>
                                                <td data-title="Area">{{v.area}}</td>
                                                <!-- <td data-title="Order Date">{{v.dateorder}}</td>
  <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                                <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
    <td data-title="Finishing/fabrics">{{v.fabric}}</td>
    <td data-title="Category">{{v.categoryname}}</td> -->
                                                <td data-title="Date">{{v.dateorder|date:'dd-MM-yyyy'}}</td>
                                                <td data-title="Name">{{v.nameClient}}</td>
                                                <!-- <td data-title="Description">
                                      <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                  </td> -->
                                                <td data-title="Amount_After_Discount">{{v.totalprice - (v.totalprice * (v.discound / 100 ))}}</td>
                                                <!-- <td data-title="Defect">{{v.defect}}</td>
                            <td data-title="Sales">{{v.sales}}</td>
                            <td data-title="Notes">
                                <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                            </td> -->
                                                <!-- <td data-title="Branch">{{v.rootname}}</td>
    <td data-title="Price">{{v.price}}</td>
    <td data-title="Supplier">{{v.suppliername}}</td>
    <td data-title="PI NO">{{v.pino}}</td>
    <td data-title="Sales">{{v.sales}}</td> -->
                                                <!-- <td data-title="Password" >{{v.username}}</td> -->

                                                <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
    <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
    </td>
    <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
    </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>